import { render, staticRenderFns } from "./CreateTeamCard.vue?vue&type=template&id=f2da8eb8&scoped=true&"
import script from "./CreateTeamCard.vue?vue&type=script&lang=js&"
export * from "./CreateTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeamCard.vue?vue&type=style&index=0&id=f2da8eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2da8eb8",
  null
  
)

export default component.exports